var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _path11, _path12, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelefonia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5AB9E5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.2,9.69a.6.6,0,0,0-.58.62.61.61,0,0,0,.63.58,6,6,0,0,1,4,1.5,5.73,5.73,0,0,1,1.44,3.95.6.6,0,0,0,.57.64h0a.6.6,0,0,0,.6-.56,6.8,6.8,0,0,0-1.79-4.88A7.09,7.09,0,0,0,40.2,9.69Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.3,9.39a9.34,9.34,0,0,0-6.46-2.46.61.61,0,1,0,0,1.21,8.19,8.19,0,0,1,5.56,2.1,7.92,7.92,0,0,1,2,5.52.61.61,0,0,0,.56.64h0a.6.6,0,0,0,.6-.57A9,9,0,0,0,47.3,9.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.22,12.66a3.71,3.71,0,0,0-3.31,2.06H22.81a3.66,3.66,0,0,1,.71,1.42h13a1.94,1.94,0,0,0,0,.24,3.72,3.72,0,0,0,3.64,3.71v23a1.54,1.54,0,0,1-1.53,1.54H23.52A3.66,3.66,0,0,1,22.81,46H38.62a3,3,0,0,0,3-3V19.83a3.71,3.71,0,0,0-1.35-7.17Zm0,6.12a2.41,2.41,0,1,1,2.41-2.4A2.41,2.41,0,0,1,40.22,18.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.1,14.72H14.78a3.35,3.35,0,0,0-3.34,3.34V42.67A3.35,3.35,0,0,0,14.78,46H19.1a3.35,3.35,0,0,0,3.34-3.34V18.06A3.35,3.35,0,0,0,19.1,14.72Zm1.92,28a1.93,1.93,0,0,1-1.92,1.92H14.78a1.93,1.93,0,0,1-1.92-1.92V18.06a1.92,1.92,0,0,1,1.92-1.92H19.1A1.92,1.92,0,0,1,21,18.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.7,27.32h7.55a2.87,2.87,0,0,0,2.86-2.86V20h-13v4.72A2.58,2.58,0,0,0,26.7,27.32Zm-1.54-6.26H36.07v3.4a1.82,1.82,0,0,1-1.82,1.81H26.7a1.54,1.54,0,0,1-1.54-1.53Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.27,32.11a.89.89,0,1,0,.89.89A.89.89,0,0,0,26.27,32.11Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.45,32.11a.89.89,0,1,0,.89.89A.89.89,0,0,0,30.45,32.11Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.8,32.11a.89.89,0,1,0,.89.89A.89.89,0,0,0,34.8,32.11Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.27,35.52a.89.89,0,1,0,.89.89A.89.89,0,0,0,26.27,35.52Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.45,35.52a.89.89,0,1,0,.89.89A.89.89,0,0,0,30.45,35.52Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 34.8,
    cy: 36.41,
    r: 0.89
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.27,38.93a.89.89,0,1,0,.89.89A.89.89,0,0,0,26.27,38.93Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.45,38.93a.89.89,0,1,0,.89.89A.89.89,0,0,0,30.45,38.93Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 34.8,
    cy: 39.82,
    r: 0.89
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefonia);
export default __webpack_public_path__ + "static/media/telefonia.e455cbd609a52a745aa847ea07c62c29.svg";
export { ForwardRef as ReactComponent };